import { BaseRepository } from '@/base/base-repository';

class ZkloginRepository extends BaseRepository {
	async sendJwt(jwt: string): Promise<void> {
		await this.httpClient({
			method: 'post',
			url: '/auth/jwt',
			data: {
				jwt,
			},
		});
	}
}

export const zkloginRepository = new ZkloginRepository();
